import React from 'react';

interface FirewallLayerStackProps {
  activeLayer: number | null;
  setActiveLayer: (idx: number | null) => void;
}


import { Settings, Fingerprint, SearchCheck, AlertTriangle } from 'lucide-react';

const layers = [
  {
    title: 'Monitor',
    description: "Analyze helpdesk calls and IT tickets in real-time",
    icon: Settings, // Represents configuration/setup
    layerLabel: '',
  },
  {
    title: 'Detect',
    description: 'Syntra AI finds anomalies like social engineering attempts or deepfakes',
    icon: Fingerprint, // Represents biometric/identity verification
    layerLabel: '',
  },
  {
    title: 'Verify',
    description: 'Trigger step-up verification right in your ITSM or call center platform',
    icon: SearchCheck, // Represents security analysis/validation
    layerLabel: '',
  },
  {
    title: 'Respond',
    description: 'Route approvals, or push alerts to SOC / SIEM',
    icon: AlertTriangle, // Represents detection/action
    layerLabel: '',
  },
];

export const FirewallLayerStack: React.FC<FirewallLayerStackProps> = ({ activeLayer, setActiveLayer }) => {
  return (
    <div className="flex flex-col items-center w-full max-w-2xl mx-auto gap-8">
      {layers.map((layer, idx) => {
        const Icon = layer.icon;
        const isActive = activeLayer === idx;
        return (
          <div
            key={layer.title}
            className={`flex flex-row items-center transition-all duration-500
              ${isActive ? 'z-20 bg-blue-700 text-white border-blue-500 shadow-lg' : 'z-10 bg-blue-900 text-blue-100 border-blue-700'}
              border rounded-2xl px-8 py-6 w-full
            `}
            onMouseEnter={() => setActiveLayer(idx)}
            onMouseLeave={() => setActiveLayer(null)}
            style={{ cursor: 'pointer' }}
          >
            <div className={`flex items-center justify-center w-14 h-14 rounded-full mr-6 transition-all duration-500 ${isActive ? 'bg-white text-blue-700' : 'bg-blue-900 text-blue-300'}`}>
              <Icon size={32} />
            </div>
            <div className="flex-1 text-left">
              <h4 className="text-lg font-semibold mb-1">{layer.title}</h4>
              <p className="text-sm mb-2">{layer.description}</p>
              <span className="text-xs font-mono tracking-widest opacity-80">{layer.layerLabel}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FirewallLayerStack; 